import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignInForm from "@components/Onboarding/SignInForm/SignInForm";
import SideImageLayout from "@components/SideImageLayout/SideImageLayout";
import { INTRO_SEEN_STORAGE_KEY } from "@constants/intro";

const SignIn: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const hasSeenIntro = localStorage.getItem(INTRO_SEEN_STORAGE_KEY);
      if (!hasSeenIntro) {
        navigate("/intro", { replace: true });
      }
    } catch {
      // if storage is unavailable, just proceed to sign-in
    }
  }, [navigate]);

  return (
    <SideImageLayout>
      <SignInForm />
    </SideImageLayout>
  );
};

export default SignIn;
